import { Typography } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { isPostEvent } from 'utils/constants';
import translations from 'utils/translations';

const RemoveSection = () => {
  // Hooks
  const intl = useIntl();
  const i18n = translations.exhibitorBookmark(intl);
  return (
    <Typography vvariant={'body2'} textAlign={'center'}>
      {isPostEvent
        ? i18n.dialogs.removePostEvent.subTitle
        : i18n.dialogs.remove.subTitle}
    </Typography>
  );
};

export { RemoveSection };
